import POST from "./api/POST";

export const merchantEmployeeLogin = async (credentials) => {
  const response = await POST(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/login`,
    credentials
  );
  return response;
};

export const forgotPasswordSendEmailCode = async (credentials) => {
  const response = await POST(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/forgot-password-send-verification-code`,
    credentials
  );
  return response;
};

export const forgotPasswordVerifyEmailCode = async (credentials) => {
  const response = await POST(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/forgot-password-verify-code`,
    credentials
  );
  return response;
};

export const forgotPasswordResetPassword = async (credentials) => {
  const response = await POST(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/reset-forgot-password`,
    credentials
  );
  return response;
};
